// extracted by mini-css-extract-plugin
export default {"root_scroller":"sW","flex_container":"tW","container":"uW","scroller":"vW","indicator":"wW","scrollButtons":"xW","selected":"yW","root_tab":"zW","root_tab_scrollable":"AW","root_scroller_mob":"BW","scroller_mob":"CW","indicator_mob":"EW","selected_mob":"FW","root_tab_mob":"GW","root_tab_mob_scrollable":"HW"};
    if(module.hot) {
      // 1711394579770
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  